import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vnMessage from '@/language/vn.json'
import enMessage from '@/language/en.json'

Vue.use(VueI18n)

const messages = {
    vn: vnMessage,
    en: enMessage,
}
var defaultLanguage = 'vn';

if($cookies.isKey('fpt_livechat_language')) {
    defaultLanguage = $cookies.get('fpt_livechat_language')
} 

const i18n = new VueI18n({
    locale: defaultLanguage, // set locale
    messages,
    fallbackLocale: 'vn',
    silentTranslationWarn: true
})

export default i18n
